// Module
var code = "<cloud-monitoring-annotation-query-editor target=\"ctrl.annotation.target\" on-query-change=\"(ctrl.onQueryChange)\" datasource=\"ctrl.datasource\" template-srv=\"ctrl.templateSrv\"></cloud-monitoring-annotation-query-editor>\n";
// Exports
var _module_exports =code;;
var path = 'public/app/plugins/datasource/cloud-monitoring/partials/annotations.editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;